/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Slim_Pearl_Whale_SpotInputs */

const en_slim_pearl_whale_spot = /** @type {(inputs: Slim_Pearl_Whale_SpotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error`)
};

const de_slim_pearl_whale_spot = /** @type {(inputs: Slim_Pearl_Whale_SpotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler`)
};

/**
* | output |
* | --- |
* | "Error" |
*
* @param {Slim_Pearl_Whale_SpotInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const slim_pearl_whale_spot = /** @type {((inputs?: Slim_Pearl_Whale_SpotInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Slim_Pearl_Whale_SpotInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_slim_pearl_whale_spot(inputs)
	return de_slim_pearl_whale_spot(inputs)
});